module.exports = __webpack_public_path__ + "media/tacklebox/assets/images/views/search/lines/red-6b34358b89b11d54dddd36c49de6621d.webp";